// src/components/Accountcode/Edit.jsx

import React, { useState, useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import AccountCodeService from "../../../../services/AccountCodeService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditAccountCode = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    projectRequired: "N",
    accountName: "",
    accountNumber: "",
    project: "",
    accountDescription: "",
    accountCategory: "",
    id: "",
  });
  const navigate = useNavigate();

  const fetchAccountcode = async () => {
    try {
      const response = await AccountCodeService.view(id);
      setFormData({
        projectRequired: response.data.projectRequired,
        accountName: response.data.accountName,
        accountNumber: response.data.accountNumber,
        project: response.data.project,
        accountDescription: response.data.accountDescription,
        accountCategory: response.data.accountCategory,
        id: response.data._id,
      });
    } catch (error) {
      console.error("Failed to fetch account code:", error);
    }
  };

  useEffect(() => {
    fetchAccountcode();
  }, [id]);

  const handleUpdate = async () => {
    try {
      await AccountCodeService.update(formData);
      toast.success("Account Code Added Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/account-code");
      }, 3000);
    } catch (error) {
      console.error("Failed to update account code:", error);
      toast.error("Failed to Update Account Code!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }finally {
     
      
    }
  };

  return (
    <div>
      <Card>
        <h1>Edit Account Code</h1>
        <Form>
          <Row className="mb-3 mt-3">
            <Col>
              <Form.Group controlId="formAccountcodeProjectRequired">
                <Form.Label>Project Required</Form.Label>
                <Form.Control
                  as="select"
                  value={formData.projectRequired}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      projectRequired: e.target.value,
                    })
                  }
                >
                  <option value="N">No</option>
                  <option value="Y">Yes</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formAccountcodeName">
                <Form.Label>Account Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter account name"
                  value={formData.accountName}
                  onChange={(e) =>
                    setFormData({ ...formData, accountName: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formAccountcodeNumber">
                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter account number"
                  value={formData.accountNumber}
                  onChange={(e) =>
                    setFormData({ ...formData, accountNumber: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId="formAccountcodeProject">
                <Form.Label>Project</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter project"
                  value={formData.project}
                  onChange={(e) =>
                    setFormData({ ...formData, project: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formAccountcodeDescription">
                <Form.Label>Account Description</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter account description"
                  value={formData.accountDescription}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      accountDescription: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="formAccountcodeCategory">
                <Form.Label>Account Category</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter account category"
                  value={formData.accountCategory}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      accountCategory: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <Button
              variant="primary"
              className="submit-btn mr-4"
              onClick={handleUpdate}
            >
              Update
            </Button>
          </div>
        </Form>
      </Card>
       {/* Toast Notification Container */}
       <ToastContainer />
    </div>
  );
};

export default EditAccountCode;
